<template>
  <div class="centered-box locations-white locations-generic">
    <div class="FreeCanoeAndKayakEvents">
      <div class="locations-title">FREE CANOE AND KAYAK EVENTS</div>
      (Sponsored by Cook County Forest Preserves--Please make your reservations
      directly through the Forest Preserves Website)
      <br />
      <br />
      <a class="Beaubien" href="https://fpdcc.com/event/beaubien-woods-celebration-2/">
        Beaubien Woods Celebration 
      </a>
      Saturday, June 10 <br />
      Paddle Flatfoot Lake. Located on the south side of Chicago, Beaubien Woods
      is home to a mix of prairie, woodland and wetland habitats.
      <br />
      <br />
      <a class="Paddle" href="https://fpdcc.com/event/paddle-day/">
        Paddle Day 
      </a>
      Friday, June 30 <br />
      Explore Busse Reservoir South Pool. One of the best-used natural areas in
      Illinois, the 3,558-acre Ned Brown Preserve includes ancient upland
      forests, one of the largest boating waters in Cook County, 13 miles of
      paved trail, an elk pasture and more.
      <br />
      <br />
      <a class="Kids" href="https://fpdcc.com/event/kids-fest-2/">
        KIDS' FEST 
        </a>
      Saturday, July 8 <br />
      Discover Wampum Lake. Located near the Illinois-Indiana border, Wampum
      Lake Nature Preserve is designated as one of the highest quality natural
      areas in the state by the Illinois Nature Preserves Commission.
      <br />
      <br />
      <a class="Latino" href="https://fpdcc.com/event/latino-conservation-weekend-canoe-clean-up/">
        LATINO CONSERVATION WEEKEND 
      </a>
          Saturday, July 22 <br />
      Tucked away in the far southeast side of Chicago, Powderhorn Lake boasts
      woodland, prairie and wetland habitats and reflects the ecological
      richness that survives across the industrialized Calumet region.
      <br />
      <br />
      <a class="Wampum" href="https://fpdcc.com/event/summer-paddling-at-wampum-lake/">
        SUMMER PADDLE--WAMPUM LAKE 
      </a>
          Saturday, August 5
          <br />
      Located near the Illinois-Indiana border, Wampum Lake Nature Preserve is
      designated as one of the highest quality natural areas in the state by the
      Illinois Nature Preserves Commission.
      <br />
      <br />
      <a class="Picnic" href="https://fpdcc.com/event/picnic-and-paddle/">
        PICNIC 'N' PADDLE 
      </a>
      Thursday, August 17
      <br />
      Part of the Des Plaines River Trail, Beck Lake is a 40-acre gem featuring
      a trailered boat launch for canoes, kayaks, rowboats, sailboats. An
      off-leash dog area provides open space for dogs to play.
      <br />
      <br />
      <a class="History" href="https://fpdcc.com/event/history-of-the-lagoons-paddle/">
        HISTORY OF THE LAGOONS PADDLE 
      </a>
        <br />
        Wednesday, August 30
        <br />
        Skokie Lagoons was previously the "Big Wet Prairie" or Skokie Marsh.
        Between 1933 and 1940, several thousand Civilian Conservation Corps (CCC)
        workers moved millions yards of earth to recontour the land, creating the
        artificial lagoons of today. This massive effort was the largest CCC
        project in the nation. So much to learn!
      <br />
      <br />
      <span>
        FALL PADDLE FESTIVAL (no link available yet) 
      </span>
        Saturday, October 14
        One final visit to Skokie Lagoons. 
        Embrace the end of the paddling season with nature-based activities on and off the water. 
        Participate in a canoe trip, guided hike, archery, pumpkin painting, nature play and more.
    </div>
  </div>
</template>

<script>
export default {
  name: "FreeCanoeAndKayakEvents",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span {
  color: green;
}
.twilight {
  color: black;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
